import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import Inside from './Inside'
import QuotationScheduleList from './Quotations/QuotationScheduleList'

function mapStateToProps (state) {
  return {

  }
}

export class QuotationSchedules extends React.Component {
  render () {
    return (
      <Inside>
        <Switch>
          <Route exact path='/quotation-schedules' component={QuotationScheduleList} />
        </Switch>
      </Inside>
    )
  }
}

export default connect(
  mapStateToProps
// Implement map dispatch to props
)(QuotationSchedules)
